export enum OnlyCountryISO {
    Angola = "ao",
    Argentina = "ar",
    Armenia = "am",
    Australia = "au",
    Austria = "at",
    Azerbaijan = "az",
    Bahamas = "bs",
    Bahrain = "bh",
    Bangladesh = "bd",
    Barbados = "bb",
    Bolivia = "bo",
    BosniaAndHerzegovina = "ba",
    Botswana = "bw",
    Brazil = "br",
    Bulgaria = "bg",
    Cameroon = "cm",
    Canada = "ca",
    Chile = "cl",
    China = "cn",
    Colombia = "co",
    CostaRica = "cr",
    Croatia = "hr",
    Cyprus = "cy",
    CzechRepublic = "cz",
    Denmark = "dk",
    Dominica = "dm",
    DominicanRepublic = "do",
    Ecuador = "ec",
    Egypt = "eg",
    ElSalvador = "sv",
    Finland = "fi",
    France = "fr",
    Gabon = "ga",
    Georgia = "ge",
    Germany = "de",
    Ghana = "gh",
    Greece = "gr",
    Guatemala = "gt",
    Haiti = "ht",
    Honduras = "hn",
    Hungary = "hu",
    Iceland = "is",
    India = "in",
    Indonesia = "id",
    Iran = "ir",
    Ireland = "ie",
    Israel = "il",
    Italy = "it",
    Jamaica = "jm",
    Japan = "jp",
    Jordan = "jo",
    Kazakhstan = "kz",
    Kenya = "ke",
    Kuwait = "kw",
    Kyrgyzstan = "kg",
    Laos = "la",
    Latvia = "lv",
    Lebanon = "lb",
    Lithuania = "lt",
    Luxembourg = "lu",
    Malaysia = "my",
    Mexico = "mx",
    Mongolia = "mn",
    Morocco = "ma",
    Mozambique = "mz",
    Myanmar = "mm",
    Nepal = "np",
    Netherlands = "nl",
    NewZealand = "nz",
    Nicaragua = "ni",
    Nigeria = "ng",
    Norway = "no",
    Oman = "om",
    Pakistan = "pk",
    Panama = "pa",
    Paraguay = "py",
    Peru = "pe",
    Philippines = "ph",
    Poland = "pl",
    Portugal = "pt",
    Qatar = "qa",
    Romania = "ro",
    SaudiArabia = "sa",
    Senegal = "sn",
    Serbia = "rs",
    Singapore = "sg",
    Slovakia = "sk",
    Slovenia = "si",
    SouthAfrica = "za",
    Spain = "es",
    SriLanka = "lk",
    Switzerland = "ch",
    Thailand = "th",
    Tunisia = "tn",
    Turkey = "tr",
    Uganda = "ug",
    Ukraine = "ua",
    UnitedArabEmirates = "ae",
    UnitedKingdom = "gb",
    UnitedStates = "us",
    Uruguay = "uy",
    Uzbekistan = "uz",
    Venezuela = "ve",
    Vietnam = "vn",
    Yemen = "ye",
    Zambia = "zm",
    Zimbabwe = "zw",
}
//# sourceMappingURL=country-iso.enum.d.ts.map